import React from 'react';
import { Spinner } from 'react-bootstrap';

const MiniSpinner = () => {
  return (
    <Spinner
      animation="border"
      variant="secondary"
      size="sm-centrado"
      role="status"
      className="p-0 m-0"
    >
      <span className="sr-only">Loading...</span>
    </Spinner>
  )
}

export default MiniSpinner;